import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

import { getEnumTranslations } from '@/locale/enum-translations';

/**
 * Use in react components, we memoize the translations
 * to avoid re-rendering the same translations.
 */
export function useEnumTranslations() {
  const { t } = useLingui();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => getEnumTranslations(), [t]);
}
